<div class="user-in-main">
    <!-- <div *ngIf="isDashboardLoading" class="w-100 text-center">
        <div id="loading-bar-spinner" class="spinner" title="please wait ...">
            <div class="spinner-icon"></div>
        </div>
    </div> -->

    <div class="left-block">
        <button title="Countable.co" mat-button mat-stroked-button color="dark" class="btn-medium back-to-website-btn"
                (click)="siteNavigate()">
                <span class="flexbox-row gap-8">
                    <i class="fa-regular fa-house"></i>
                    <span class="button-label">Back To Website</span>
                </span>
        </button>
        <section class="slider_container">
            <section class="slider">
                <div class="slide one">
                    <img src="/assets/images/login-screen-images/bg-0.jpg" alt="" />
                </div>
                <div class="slide two">
                    <img src="/assets/images/login-screen-images/bg-1.jpg" alt="" />
                </div>
            </section>
        </section>
        <a class="support-link text-white" href="mailto:support@countable.co" title="support@countable.co">support&#64;countable.co</a>
    </div>

    <div class="right-block">
        <div class="toast-container toast-top-right" *ngIf="isAccountPaused">
            <div class="ngx-toastr toast-error ">
                <div class="toast-message d-flex flex-column flex-wrap gap-6">
                    <button mat-button class="close" (click)="closeErrorToaster()">
                        <i class="fa-regular fa-xmark clear-icon"></i>
                    </button>
                    <span class="fw-medium">Account Paused!</span>
                    <span>Please contact your Super Admin <br/>
                        to re-activate the account.
                    </span>
                </div>
            </div>
        </div>
        <div class="content-block br-12 bg-white gap-24">
            <div class="brand align-self-center">
                <img src="/assets/images/global/brand-primary.svg" alt="Countable"/>
            </div>
            <ng-container *ngIf="isLoginWindow || isMfaWindow">
                <form class="d-flex flex-column gap-20" [formGroup]="loginForm" autoComplete="on"
                      *ngIf="isLoginWindow">
                    <h3 class="title text-center mb-24">Secure Login</h3>
                    <mat-form-field class="fixed-label label-none w-100" floatLabel="always">
                        <mat-label>Email</mat-label>
                        <input matInput formControlName="emailId" placeholder="E-mail" autocomplete="username" required>
                    </mat-form-field>
                    <mat-form-field class="fixed-label label-none w-100 icon-form-after" floatLabel="always">
                        <mat-label>Password</mat-label>
                        <input type="password" [type]="hide ? 'password' : 'text'" formControlName="password"
                               autocomplete="current-password" matInput placeholder="Password" required>
                        <span matSuffix>
                            <button mat-button class="button-text" (click)="hide = !hide">
                                <i class="fa-regular"[ngClass]="(hide ? 'fa-eye-slash' : 'fa-eye')"></i>
                            </button>
                        </span>
                    </mat-form-field>

                    <div class="d-flex flex-row align-items-center justify-content-between">
                        <mat-checkbox formControlName="rememberMe">Remember Me</mat-checkbox>
                        <a href="/forgotpassword" class="text-link" title="Forgot Password?"
                           routerLink="/forgotpassword">Forgot Password?</a>
                    </div>

                    <button mat-button mat-flat-button [disabled]="isLoginInProgress" class="w-100 button-normal"
                            (click)="login()"
                            color="primary">
                            @if(!isLoginInProgress){
                                <span>Login</span>
                            }@else{
                                <span class="smooth-gradient-ring-s"></span> 
                            }                  
                    </button>

                    <div class="seprator m-0">
                        <span class="seprator-content">
                            Or continue with
                        </span>
                    </div>
                    <div class="flexbox-row flex-wrap gap-16">
                        <button mat-button mat-stroked-button color="dark" class="button-medium other-log-button"
                                (click)="loginWithOAuthKickOff('xero')">
                            <img src="./assets/images/ui-uplift-icons/logos/xero-circle-logo.svg" alt="xero">
                            Sign in with Xero
                        </button>
                        <button mat-button mat-stroked-button color="dark" class="button-medium other-log-button"
                                (click)="loginWithOAuthKickOff('sage')">
                            <img src="./assets/images/ui-uplift-icons/logos/sage-small-logo.svg" alt="Sage">
                            Sign in with Sage
                        </button>
                        <div class="button-medium mat-button mat-stroked-button p-0 other-log-button overflow-hidden"
                             #googleSSO></div>
                        <button mat-button mat-stroked-button class="button-medium qb-button other-log-button"
                                (click)="loginWithOAuthKickOff('quickbooks')">
                            Sign in with Intuit
                        </button>
                    </div>
                </form>
                <ng-container *ngIf="isMfaWindow">
                    <div class="d-flex flex-column gap-20">
                        <h3 class="title text-center d-flex flex-column mb-3">
                            Welcome back
                            <span class="text-primary">{{ user.fullName }}</span>
                        </h3>
                        <form [formGroup]="otpForm">
                            <mat-form-field class="fixed-label label-none w-100 icon-form-after"
                                            floatLabel="always">
                                <mat-label>Enter Pin</mat-label>
                                <input matInput formControlName="otpNumber" (input)="verifyOTP($event)"
                                       placeholder="Enter your code" minlength="6" maxlength="6" max="999999"
                                       pattern="[0-9]{6}" required>
                                <p class="error-message" *ngIf="isInvalidOtp">
                                    You have entered wrong code, try again
                                </p>
                            </mat-form-field>
                        </form>
                        <div class="d-flex gap-16 flex-column align-items-center" *ngIf="mfaTypeData.type=='EMAIL'">
                            <p class="d-flex flex-row justify-content-between gap-16 align-items-center w-100">
                                Didn't received code?
                                <span class="d-flex flex-row align-items-center gap-4">
                                    <ng-container *ngIf="resendTimer > 0">
                                        <span class="fw-semibold">in {{ resendTimer }}s</span>
                                    </ng-container>
                                    <a class="text-link" (click)="getEmailAuthentication(true)">Resend Code</a>
                                </span>
                            </p>
                            <p>Enter the 6-digit verification code received in <span
                                    class="fw-semibold">{{ user.username }}</span></p>
                        </div>

                        <p *ngIf="mfaTypeData.type=='GOOGLE_AUTHENTICATOR'">Enter the Google Authenticator App
                            generated 6-digit verification code here</p>

                        <button mat-button mat-flat-button color="primary" class="button-normal mt-2"
                                [disabled]="!isValidOtp" (click)="verifyCode()">
                            Continue
                        </button>
                    </div>
                </ng-container>

                <p class="get-account text-center text-gray-5 mt-32">
                    Don't have an account?
                    <a class="text-link" routerLink="/signup" title="Sign up">Sign Up</a>
                </p>
            </ng-container>
            <ng-container *ngIf="firm && firm.isDeleted">
                <div class="accountlocked">
                        <span class="icon-outer mb-lg-4 mb-3 mx-auto bg-error-1">
                            <i class="fa-regular fa-triangle-exclamation text-error"></i>
                        </span>
                    <h4 class="title text-center mb-lg-4 mb-3">Your account is 'Deleted'</h4>
                    <button title="Return to login"
                       class="text-link fs-14 align-self-center mb-lg-4 mb-3" (click)="goToLogin()">Return to login</button>
                </div>
            </ng-container>
            <div class="terms">
                <div role="list" class="items-list bottom-nav">
                    <button class="bottom-nav-item text-link fs-14" title="Privacy Policy"
                       (click)="openTermsPrivacyDialog('privacy-policy')">Privacy Policy</button>
                    <button class="bottom-nav-item text-link fs-14"
                       title="Terms of Use & Privacy Policy" (click)="openTermsPrivacyDialog('terms-of-Use')">Terms of
                        Use</button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Billing Problem -->
<ng-template #loginProblemForNormalUsers>
    <div class="countable-dialog" style="width: 400px;">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
            <span class="badge badge-error badge-circle icon-bordered-error">
                <i class="fa-regular fa-circle-exclamation text-error"></i>
            </span>
        </div>
        <div mat-dialog-content class="content dialog-body-content text-center gap-8 mt-2 mb-32">
            <h5>Sorry for the inconveniences</h5>
            <div>
                <p>There are some changes in your account that require your administrator's attention. We've notified them, and no action is needed from you at this time.</p>
            </div>
        </div>
        <div mat-dialog-actions class="dialog-footer button-group">
            <button mat-button mat-flat-button class="button-normal" color="primary"
                    [mat-dialog-close]="true">Ok
            </button>
        </div>
    </div>
</ng-template>

